require('./polyfills/Array.find');
require('./polyfills/Object.assign');

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueEvents from 'vue-events'
import vueLogger from 'vue-logger'
import VueJWPlayer from './plugins/vue-jwplayer/index.js'
import THPHelpers from './plugins/thp-helpers/index.js'
import Manager from './plugins/manager/index.js'
import CustomLog from './plugins/custom-log/index'
import VideoAdSchedule from './plugins/video-ad-schedule/index.js'
import Homad from './plugins/homad/index.js'

import PlayerCanvas from './PlayerCanvas'
import router from './router'



Vue.config.productionTip = false

var settings = {}
var item = {}
var error = {
  error: false,
  msg: 'no error'
}

// Object.defineProperty(Vue.prototype, '$settings', {
//   get () {
//     return settings
//   },
//   set (value) {
//     settings = value
//   }
// })

Object.defineProperty(Vue.prototype, '$item', {
  get () {
    return item
  },
  set (value) {
    item = value
  }
})

Object.defineProperty(Vue.prototype, '$error', {
  get () {
    return error
  },
  set (value) {
    error = value
  }
})


Vue.use(VueEvents)
Vue.use(CustomLog)
Vue.use(vueLogger, {
  prefix: 'VueJW',
  dev: true,
  shortname: true,
  levels: ['log', 'info', 'warn', 'debug', 'error', 'dir']
})
Vue.use(THPHelpers)
Vue.use(Manager, router)
Vue.use(VideoAdSchedule)
Vue.use(Homad)
Vue.use(VueJWPlayer, {key: 'K4yWE9/5fSPPg4NHVxiynb+wHVJwmXXKyszp7Q=='})

/* eslint-disable no-new */
const app = new Vue({
  el: '#playerCanvas',
  router,
  template: '<PlayerCanvas/>',
  components: { PlayerCanvas },
    mounted() {
        console.log('hey');
        // var vm = this;
        // router.onReady(() => {
        //     console.log('router ready', this);
        //     vm.$newSettings.init();
        // })


    }
})



// WEBPACK FOOTER //
// ./src/main.js